<template>
    <div class="brand-root">
        <BrandHeader :key="$route.fullPath"/>
        <router-view/>
        <BrandFooter v-if="$route.meta.requiresFooter !== false"/>
    </div>
</template>

<script>
// 브랜드/auth 레이아웃에 필요한 컴포넌트 CSS
import('@/assets/css/component/header.css');
import('@/assets/css/component/button.css');
import('@/assets/css/component/footer.css');
import('@/assets/css/component/frame.css');
import('@/assets/css/component/tost.css');
import('@/assets/css/component/popup.css');
import('@/assets/css/component/snackbar.css');

import BrandHeader from "@/components/layout/BrandHeader.vue";
import BrandFooter from "@/components/layout/BrandFooter.vue";

export default {
    name: 'BrandLayout',
    components: {BrandFooter, BrandHeader},
    beforeRouteUpdate(to, from, next) {
        next();
    },
};
</script>

<style>
/*
 * brand-root 네임스페이스 리셋
 * service 페이지 CSS(button.css 등)가 이미 로드된 경우 brand/auth 페이지에
 * 영향을 주지 않도록 충돌 규칙을 명시도로 재정의한다.
 */
.brand-root button:hover {
    transform: none;
    transition: none;
}
</style>

<style lang="scss">
/*
 * brand.scss는 non-scoped로 로드한다.
 * scoped 사용 시 자식 컴포넌트(BrandHome 등)의 .content-wrapper, .main-content에
 * 스코프 속성이 전달되지 않아 스타일이 적용되지 않는 문제를 방지한다.
 */
@import '@/assets/css/page/brand.scss';

.brand-root .header-brand .brand-menu {
    font-size: 16px;
    gap: 40px;
}

.brand-root .header-brand .brand-menu a {
    color: #111111;
}
</style>
